import { render, staticRenderFns } from "./OtaSync.vue?vue&type=template&id=00b40636&scoped=true&"
import script from "./OtaSync.vue?vue&type=script&lang=js&"
export * from "./OtaSync.vue?vue&type=script&lang=js&"
import style0 from "./OtaSync.vue?vue&type=style&index=0&id=00b40636&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b40636",
  null
  
)

export default component.exports